import { render, staticRenderFns } from "./WinnerLooks.vue?vue&type=template&id=23c5d77f&scoped=true&"
import script from "./WinnerLooks.vue?vue&type=script&lang=js&"
export * from "./WinnerLooks.vue?vue&type=script&lang=js&"
import style0 from "./WinnerLooks.vue?vue&type=style&index=0&id=23c5d77f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5d77f",
  null
  
)

export default component.exports